export function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function icon(
  name:
    | "arrow"
    | "back"
    | "book"
    | "check"
    | "clock"
    | "copy"
    | "document"
    | "kit"
    | "lock"
    | "pause"
    | "play"
    | "search"
    | "shield"
    | "spark"
    | "trash",
): string {
  const paths: Record<typeof name, string> = {
    arrow: '<path d="M5 12h14m-5-5 5 5-5 5"/>',
    back: '<path d="m15 18-6-6 6-6"/>',
    book: '<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H11v16H6.5A2.5 2.5 0 0 0 4 21.5v-16Z"/><path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H13v16h4.5a2.5 2.5 0 0 1 2.5 2.5v-16Z"/>',
    check: '<path d="m5 12 4 4L19 6"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    copy: '<rect x="8" y="8" width="11" height="11" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
    document: '<path d="M7 3h7l4 4v14H7V3Z"/><path d="M14 3v5h5M10 12h5M10 16h5"/>',
    kit: '<path d="M4 8h16v12H4V8Z"/><path d="M9 8V5h6v3M4 12h16M10 12v2h4v-2"/>',
    lock: '<rect x="5" y="10" width="14" height="10" rx="3"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
    pause: '<path d="M9 5v14M15 5v14"/>',
    play: '<path d="m8 5 11 7-11 7V5Z"/>',
    search: '<circle cx="11" cy="11" r="7"/><path d="m16 16 5 5"/>',
    shield: '<path d="M12 3 5 6v5c0 4.6 2.9 8.2 7 10 4.1-1.8 7-5.4 7-10V6l-7-3Z"/><path d="m9 12 2 2 4-4"/>',
    spark: '<path d="m12 3 1.4 4.6L18 9l-4.6 1.4L12 15l-1.4-4.6L6 9l4.6-1.4L12 3Z"/><path d="m19 15 .8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z"/>',
    trash: '<path d="M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14M10 11v6M14 11v6"/>',
  };
  return `<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths[name]}</svg>`;
}

export function choiceGroup(
  legend: string,
  field: string,
  selected: string,
  choices: Array<{ id: string; label: string; hint?: string }>,
  action = "choose",
): string {
  return `
    <fieldset class="lp-choice-group">
      <legend>${escapeHtml(legend)}</legend>
      <div class="lp-choice-grid">
        ${choices
          .map(
            (choice) => `
              <button
                class="lp-choice ${selected === choice.id ? "is-selected" : ""}"
                type="button"
                data-action="${action}"
                data-field="${escapeHtml(field)}"
                data-value="${escapeHtml(choice.id)}"
                data-focus-key="${action}-${escapeHtml(field)}-${escapeHtml(choice.id)}"
                aria-pressed="${selected === choice.id}"
              >
                <span>${escapeHtml(choice.label)}</span>
                ${choice.hint ? `<small>${escapeHtml(choice.hint)}</small>` : ""}
              </button>
            `,
          )
          .join("")}
      </div>
    </fieldset>
  `;
}

export function feedback(message: string, positive: boolean, title?: string): string {
  if (!message) return "";
  return `
    <div class="lp-feedback ${positive ? "lp-feedback--positive" : "lp-feedback--nudge"}" role="status" aria-live="polite">
      ${icon(positive ? "check" : "spark")}
      <div>
        ${title ? `<strong>${escapeHtml(title)}</strong>` : ""}
        <p>${escapeHtml(message)}</p>
      </div>
    </div>
  `;
}
